// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputReadonly::part(input){

    background-color: #f5f5f5;
    border: none;
    width:100%;
}


.inputReadonly::part(field){

   
    border: none;
   
}

.DetailsLabel{

    width:50%;
    font-size: 14px;
    color: black;
    align-self: center;
}


.Project{
width:100%;
font-size:18px;
border-bottom: 2px solid grey;
padding-bottom:10px;
 margin-bottom:10px;
  color:rgb(66, 176, 213);
  font-weight: bold;

}

.ProjectTitle{
    width:100%;
    font-size:18px;
    padding-bottom:10px;
      color:rgb(0, 36, 61);
      font-weight: bold;

}


/* .closePhaseButton{
    padding: 0 10px !important;
    width: max-content !important;
    background-color: rgb(0, 36, 61) !important;
    color: #fff !important;
} */

.closePhaseButton:disabled,.closePhaseButton[disabled]{

    background-color:  lightgrey !important;
    /* color:black !important; */
}


/* mc-input.rightAlignInput::part(input) {
    text-align: right;
  } */`, "",{"version":3,"sources":["webpack://./src/styles/LeadAndExecute.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,UAAU;AACd;;;AAGA;;;IAGI,YAAY;;AAEhB;;AAEA;;IAEI,SAAS;IACT,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;AACA,UAAU;AACV,cAAc;AACd,6BAA6B;AAC7B,mBAAmB;CAClB,kBAAkB;EACjB,uBAAuB;EACvB,iBAAiB;;AAEnB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,mBAAmB;MACjB,oBAAoB;MACpB,iBAAiB;;AAEvB;;;AAGA;;;;;GAKG;;AAEH;;IAEI,uCAAuC;IACvC,4BAA4B;AAChC;;;AAGA;;KAEK","sourcesContent":[".inputReadonly::part(input){\n\n    background-color: #f5f5f5;\n    border: none;\n    width:100%;\n}\n\n\n.inputReadonly::part(field){\n\n   \n    border: none;\n   \n}\n\n.DetailsLabel{\n\n    width:50%;\n    font-size: 14px;\n    color: black;\n    align-self: center;\n}\n\n\n.Project{\nwidth:100%;\nfont-size:18px;\nborder-bottom: 2px solid grey;\npadding-bottom:10px;\n margin-bottom:10px;\n  color:rgb(66, 176, 213);\n  font-weight: bold;\n\n}\n\n.ProjectTitle{\n    width:100%;\n    font-size:18px;\n    padding-bottom:10px;\n      color:rgb(0, 36, 61);\n      font-weight: bold;\n\n}\n\n\n/* .closePhaseButton{\n    padding: 0 10px !important;\n    width: max-content !important;\n    background-color: rgb(0, 36, 61) !important;\n    color: #fff !important;\n} */\n\n.closePhaseButton:disabled,.closePhaseButton[disabled]{\n\n    background-color:  lightgrey !important;\n    /* color:black !important; */\n}\n\n\n/* mc-input.rightAlignInput::part(input) {\n    text-align: right;\n  } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
